// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-264e0924]{color:#00b925}.title.red[data-v-264e0924]{color:#ff4747}.work[data-v-264e0924]{margin-top:4px}.address[data-v-264e0924]{width:20px;height:20px}.show-map[data-v-264e0924]{margin-left:37px;margin-bottom:0!important}@media (min-width:576px){.mt[data-v-264e0924]{margin-top:-20px}}.mt .card-body[data-v-264e0924]{padding-top:0}", ""]);
// Exports
module.exports = exports;
